let onUnauthorized = () => {}

export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler
}

// A failed login is the user mistyping a password, not a session going stale.
const isLoginCall = (input) => String(input).indexOf('/api/auth/login') !== -1

// Every API call rides on the session cookie. In production the UI and the API
// share an origin, so the browser would send it anyway, but `npm start` serves
// the UI from :3000 and fetch drops cookies cross-origin unless asked not to.
const sessionFetch = async (input, init = {}) => {
  const response = await fetch(input, { ...init, credentials: 'include' })

  if (response.status === 401 && !isLoginCall(input)) {
    onUnauthorized()
  }

  return response
}

export default sessionFetch
